import {
  Store, Utensils, Briefcase, Home, ShoppingBag, Car, Building, Wrench,
  UserCheck, HeartPulse, Sparkles, Calendar, Users, GraduationCap, Compass,
} from "lucide-react";

const MAP = {
  Store, Utensils, Briefcase, Home, ShoppingBag, Car, Building, Wrench,
  UserCheck, HeartPulse, Sparkles, Calendar, Users, GraduationCap, Compass,
};

export const ICON_NAMES = Object.keys(MAP);

export function CategoryIcon({ name, className = "w-5 h-5" }) {
  const C = MAP[name] || Store;
  return <C className={className} />;
}
